import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 10px 20px 10px 50px;
`

export const Row = styled(Container)`
  width: 100%;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 10px;
  /* Abaixo do fundo dos diálogos do @cutilei/ui (z-index 50), acima de todo o resto do site (até 10) */
  z-index: 40;
`

export const Column = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-top: 10px;
`

export const SubContainer = styled.div`
  display: grid;
  grid-template-columns: 230px 1fr;
  align-items: flex-start;
  padding: 5px 10px 10px;
`

export const LoadingBackground = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 6;
`

export const Header = styled.div`
  display: block;
  position: fixed;
  top: 0;
  background-color: #FFFFFF;
  width: 100%;
  height: 90px;
  z-index: 2;
`

export const BusinessContainer = styled.div`
  width: 100%;
  max-width: 230px;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: center;
  padding: 10px;
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 15px;
  gap: 10px;
  cursor: ${({ clickable }) => clickable ? 'pointer' : 'default'};
`

export const RatingContainer = styled.span`
  display: flex;
  z-index: 6;
  position: absolute;
  top: -8px;
  right: -8px;
  height: 18px;
  padding: 0px 6px 0px 4px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 3px;
  border-radius: 15px;
  border: 1px solid #EEEEEE;
  background-color: #FFFFFF;

  h3 {
    font-size: 12px;
    line-height: 20px;
    font-weight: bold;
    text-align: center;
    margin: 0px;
  }
`

export const CalendarContainer = styled.div`
  width: 100%;
  position: sticky;
  top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 2px;
  z-index: 4;
  gap: 10px;
`

export const Schedules = styled.div`
  padding: 0px 20px;
  display: flex;
  justify-content: flex-start;
`

export const ImageButton = styled.button`
  position: relative;
  width: 55px;
  height: 55px;
  padding: 0px;
  border: 0px;
  border-radius: 10px;
`

export const Image = styled.img`
  width: 55px;
  height: 55px;
  border: 1px solid #DDDDDD;
  border-radius: 10px;
`

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 6px;
  align-self: center;
  z-index: 4;
`

export const SubTitle = styled.h3`
  font-size: 15px;
  font-weight: 500;
  margin: 0px;
`

export const LinkText = styled(Link)`
  text-decoration: none;
  font-size: 16px;
`

export const Label = styled.p`
  font-size: 16px;
  align-self: center;
  margin-top: 10px;
`

export const TooltipLabel = styled.label`
  text-align: center;
  color: #FFFFFF;
  margin: 0px;
`
